import type { Distance, Pixel } from "@pdfking/math"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"
import { RecordMap } from "@pdfking/tfunc"

export const ConvertPixels = <T extends Record<string, Pixel>>(
  options: Pick<PdfEngineOptions, "unit_to_px">,
  rect: T
): { [K in keyof T]: Distance } =>
  RecordMap(v => ((v as number) / options.unit_to_px) as Distance, rect)
